import { Component } from '@angular/core';
import { BaseDetailPageComponent } from 'src/app/components/pages/base-detail-page/base-detail-page.component';
import BaseDetailPageConfig from 'src/app/models/base-detail-page.config';
import { ProposalsService } from 'src/app/services/api/proposals.service';
import { RouteService } from 'src/app/services/route.service';

@Component({
  selector: 'app-proposal-steps-detail-page',
  imports: [BaseDetailPageComponent],
  templateUrl: './proposal-steps-detail-page.component.html',
  styleUrl: './proposal-steps-detail-page.component.scss'
})
export class ProposalStepsDetailPageComponent {
baseDetailPageConfig!: BaseDetailPageConfig;
  readonlyUserDetail: boolean

  proposalStep?: any;

  constructor(
    private proposalsService: ProposalsService,
    private routeService: RouteService
  ) {
    this.readonlyUserDetail = true
  }

  ngOnInit(): void {

    this.baseDetailPageConfig = {
      pageTitle: 'Proposal Step',
      cardTitle: 'Proposal Step Detail',
      editItemButton: {
        type: 'success',
        title: 'Edit Proposal Step',
        onClick: () => {
          this.routeService.proposalStepsUpdate(this.proposalStep.proposalStepId);
        }
      },
      dataList: {
        data: null,
        rows: [
          {
            attribute: 'code',
            label: 'Code',
            value: (item: any) => {
              return item.code;
            }
          },
          {
            attribute: 'name',
            label: 'Name',
            value: (item: any) => {
              return item.name;
            }
          },
        ]
      },
      apiDetailService: (proposalStepId: number) => this.proposalsService.detailSettingsProposalSteps(proposalStepId),
      routeParamName: 'proposalStepId',
      responseModelName: 'proposalStep',
    };

  }

  onLoadedDetail(data: any) {
    this.proposalStep = data;
  }
}
